module.exports = __webpack_public_path__ + "img/logo-mini.55cc258e.png";